import { css } from "@emotion/css";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const inputStyles = css`
    all: inherit;
    width: 500px;
    margin: 0 0 3px;
    padding: 0;
`;

export const placeholderCss = css`
    font-style: italic;
`;

export const editIconButtonCss = css`
    margin-top: -5px;
`;

export const textContainerCss = css`
    width: 600px;
`;

export const textAreaCss = css`
    width: 100%;
    margin-top: -4px;
    margin-bottom: 9px;
    margin-left: -11px;

    border-bottom: solid ${Colors.Yellow.V200};

    &:after {
        align-self: center;
        font-size: 12px;
        color: ${Colors.Black.V150};
    }

    textarea.ant-input {
        ${Fonts.Paragraph.P200};
        overflow-y: hidden;
    }
`;

export const spanCss = css`
    word-break: break-all;
`;
